import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from 'rebass';
import { Card, Button, Divider, Icon, Image, Label, Message } from 'semantic-ui-react';
import { Form, Input } from 'formsy-semantic-ui-react';
import { Text } from '@tcaster/tcaster-web-lib';
import ReactGA from 'react-ga';

import { resolveErrorCode } from '../LoginForm/errorCodeUtil';

import { errorLabel } from 'Util/form';

const StyledCard = styled(Card)`
  &.ui.card {
    border-radius: 0;
    width: 100%;
    min-width: 320px;
  }
  &.ui.card > .content {
    ${'' /* align-items: center; */};
  }
`;

const FWButton = styled(Button)`
  width: 100%;
`;

const SImage = styled(Image)`
  &&&& {
    display: block;
    max-width: 210px;
    margin: 16px auto 8px;
  }
`;

const IconBot = styled(props => <i {...props} className={`tcst-tcasbot ${props.className}`} />)`
  font-size: 140%;
  vertical-align: sub;
  margin-right: 4px;
  line-height: 14px !important;
`;

const FormBox = styled(Box)`
  max-width: 300px;
`;

class RegisterForm extends Component {
  static propTypes = {
    logoUrl: PropTypes.string,
    onEmailRegisterClick: PropTypes.func,
    onFacebookRegisterClick: PropTypes.func,
    errorCode: PropTypes.string,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    logoUrl: '/images/tcaster_logo.png',
    onEmailRegisterClick: () => {},
    onFacebookRegisterClick: () => {},
  };

  constructor(props) {
    super(props);
    this.register = _.throttle(this.register, 1000);
    this.handleFBRegister = _.throttle(this.handleFBRegister, 1000);
  }

  register = form => {
    try {
      ReactGA.event({
        category: 'AUTH',
        action: 'Register with email',
      });
    } catch (err) {
      console.log('ga error:', err);
    }
    const { username, password } = form;
    this.props.onEmailRegisterClick({ username, password });
  };

  handleFBRegister = () => {
    try {
      ReactGA.event({
        category: 'AUTH',
        action: 'Register with Facebook',
      });
    } catch (err) {
      console.log('ga error:', err);
    }
    this.props.onFacebookRegisterClick();
  };
  renderEmailRegister() {
    const { loading } = this.props;
    return (
      <Form onValidSubmit={this.register}>
        <Form.Field>
          <Text is="label" fontWeight={400} style={{ fontWeight: 400 }}>
            อีเมล
          </Text>
          <Input
            name="username"
            required
            validations="isEmail"
            validationErrors={{
              isEmail: 'อีเมลต้องอยู่ในรูปแบบของ username@domain.com',
              isDefaultRequiredValue: 'กรุณาใส่อีเมล',
            }}
            placeholder=""
            errorLabel={errorLabel}
          />
        </Form.Field>
        <Form.Field>
          <Text is="label" fontWeight={400} style={{ fontWeight: 400 }}>
            รหัสผ่าน
          </Text>
          <Input
            name="password"
            required
            type="password"
            placeholder=""
            validationErrors={{
              isDefaultRequiredValue: 'กรุณาใส่รหัสผ่าน',
              minLength: 'รหัสผ่านต้องมีความยาว 6 ตัวขึ้นไป',
            }}
            validations="minLength:6"
            errorLabel={errorLabel}
          />
        </Form.Field>
        <Form.Field>
          <Text is="label" fontWeight={400} style={{ fontWeight: 400 }}>
            ยืนยันรหัสผ่าน
          </Text>
          <Input
            name="confirmPassword"
            required
            type="password"
            placeholder=""
            validations="equalsField:password"
            validationErrors={{
              isDefaultRequiredValue: 'กรุณายืนยันรหัสผ่าน',
              equalsField: 'รหัสผ่านไม่ตรงกับรหัสผ่านด้านบน',
            }}
            errorLabel={errorLabel}
          />
        </Form.Field>
        <FWButton
          primary
          circular
          size="medium"
          type="submit"
          content={
            <span style={{ fontWeight: 400 }}>
              <IconBot />
              ลงทะเบียน
            </span>
          }
          loading={loading}
          disabled={loading}
        />
      </Form>
    );
  }

  render() {
    const { logoUrl, loading, errorCode } = this.props;
    return (
      <StyledCard>
        <Card.Content>
          <SImage src={logoUrl} centered />
          <Box mb={2} />
          <FormBox pb={3} mx="auto" pt={3}>
            <Box mb={1}>
              <Text fontWeight={500} textAlign="center">
                ลงทะเบียน
              </Text>
            </Box>
            {errorCode && <Message negative>{resolveErrorCode(errorCode)}</Message>}

            {this.renderEmailRegister()}
            <Divider horizontal>
              <Text fontWeight={300}>หรือ</Text>
            </Divider>
            <FWButton
              circular
              size="medium"
              color="facebook"
              onClick={this.handleFBRegister}
              content={
                <span style={{ fontWeight: 400 }}>
                  <Icon name="facebook" />
                  ลงทะเบียนด้วย Facebook
                </span>
              }
              loading={loading}
              disabled={loading}
            />
          </FormBox>
        </Card.Content>
      </StyledCard>
    );
  }
}

export default RegisterForm;
